// extracted by mini-css-extract-plugin
module.exports = {"wrap":"UserAccountPopover-wrap","container":"UserAccountPopover-container","popover":"UserAccountPopover-popover","avatar":"UserAccountPopover-avatar"};